const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/agents/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
import { getRootLoaderData } from "@/types/intl";
import { parseAdminAgentsSearch } from "./-parse-admin-agents-search";
export const Route = createFileRoute("/_app/admin/agents/")({
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "adminAgents"
    });
    return {
      meta: [{
        title: adminPageTitle(t("pageTitle"))
      }]
    };
  },
  validateSearch: parseAdminAgentsSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});